module.exports = __webpack_public_path__ + "img/86.something_else.1e0e2485.svg";